(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ri-reviews"] && !Shopify.designMode) return;
  try {
    

  (() => {
    const scriptUrl =
      'https://widget.reviews.io/polaris/build.js';

    function loadReviewsIO() {
      if (typeof window.ReviewsWidget === 'function') {
        return Promise.resolve();
      }

      if (window.__gramsReviewsIOPromise) {
        return window.__gramsReviewsIOPromise;
      }

      window.__gramsReviewsIOPromise = new Promise(
        (resolve, reject) => {
          const script = document.createElement('script');

          script.src = scriptUrl;
          script.async = true;

          script.onload = () => {
            if (typeof window.ReviewsWidget === 'function') {
              resolve();
            } else {
              window.__gramsReviewsIOPromise = null;
              reject(
                new Error(
                  'REVIEWS.io Polaris constructor was not found.'
                )
              );
            }
          };

          script.onerror = () => {
            window.__gramsReviewsIOPromise = null;

            reject(
              new Error('Could not load REVIEWS.io Polaris.')
            );
          };

          document.head.appendChild(script);
        }
      );

      return window.__gramsReviewsIOPromise;
    }

    async function initReviewsIO(root = document) {
      const containers = [];

      if (
        root instanceof Element &&
        root.matches('[data-reviewsio-widget]')
      ) {
        containers.push(root);
      }

      if (root.querySelectorAll) {
        containers.push(
          ...root.querySelectorAll('[data-reviewsio-widget]')
        );
      }

      for (const container of containers) {
        if (
          container.dataset.reviewsioInitialized === 'true'
        ) {
          continue;
        }

        const storeId = container.dataset.storeId;
        const productSku = container.dataset.productSku;

        if (!storeId || !productSku) {
          console.error(
            'REVIEWS.io: Missing Store ID or product identifiers.',
            container
          );
          continue;
        }

        container.dataset.reviewsioInitialized = 'true';

        try {
          await loadReviewsIO();

          if (!container.isConnected) {
            delete container.dataset.reviewsioInitialized;
            continue;
          }

          const config = {
            store: storeId,
            widget: 'polaris',

            options: {
              types: 'product_review,questions',
              lang: 'en',
              per_page: 15,
              enable_sentiment_analysis: true,

              product_review: {
                sku: productSku,
                enable_rich_snippets: false
              },

              questions: {
                hide_if_no_results: false,
                enable_ask_question: true,
                show_dates: true,
                grouping: productSku
              },

              header: {
                enable_summary: true,
                enable_ratings: true,
                enable_attributes: true,
                enable_image_gallery: true,
                enable_percent_recommended: false,
                enable_write_review: true,
                enable_ask_question: true,
                enable_sub_header: true,
                rating_decimal_places: 2,
                use_write_review_button: false,
                enable_if_no_results: false
              },

              sentiment: {
                badge_text: 'Our Customers Say',
                enable_rating_breakdown: false
              },

              filtering: {
                enable: true,
                enable_text_search: true,
                enable_sorting: true,
                enable_product_filter: false,
                enable_media_filter: true,
                enable_overall_rating_filter: true,
                enable_language_filter: false,
                enable_language_filter_language_change: false,
                enable_ratings_filters: true,
                enable_attributes_filters: true,
                enable_expanded_filters: false
              },

              reviews: {
                enable_avatar: true,
                enable_reviewer_name: true,
                enable_reviewer_address: false,
                enable_verified_badge: true,
                enable_subscriber_badge: true,
                enable_reviewer_recommends: true,
                enable_attributes: true,
                enable_product_name: true,
                enable_link_product: false,
                enable_replies: true,
                enable_images: true,
                enable_ratings: true,
                enable_share: true,
                enable_helpful_vote: true,
                enable_helpful_display: true,
                enable_report: true,
                enable_date: true,
                combine_title_stars: true,
                show_untranslated: false
              },

              translations: {
                'Verified Customer': 'Verified Customer'
              },

              styles: {
                '--base-font-size': '16px',

                '--common-button-font-family': 'inherit',
                '--common-button-font-size': '16px',
                '--common-button-font-weight': '500',
                '--common-button-letter-spacing': '0',
                '--common-button-text-transform': 'none',
                '--common-button-vertical-padding': '10px',
                '--common-button-horizontal-padding': '20px',
                '--common-button-border-width': '1px',
                '--common-button-border-radius': '0px',

                '--primary-button-bg-color': '#0E1311',
                '--primary-button-border-color': '#0E1311',
                '--primary-button-text-color': '#FFFFFF',

                '--secondary-button-bg-color': 'transparent',
                '--secondary-button-border-color': '#0E1311',
                '--secondary-button-text-color': '#0E1311',

                '--common-star-color': '#0E1311',
                '--common-star-disabled-color': 'rgba(0,0,0,0.25)',
                '--medium-star-size': '22px',
                '--small-star-size': '19px',

                '--heading-text-color': '#0E1311',
                '--heading-text-font-weight': '600',
                '--heading-text-font-family': 'inherit',
                '--heading-text-line-height': '1.4',
                '--heading-text-letter-spacing': '0',
                '--heading-text-transform': 'none',

                '--body-text-color': '#0E1311',
                '--body-text-font-weight': '400',
                '--body-text-font-family': 'inherit',
                '--body-text-line-height': '1.5',
                '--body-text-letter-spacing': '0',
                '--body-text-transform': 'none',

                '--inputfield-text-font-family': 'inherit',
                '--input-text-font-size': '14px',
                '--inputfield-text-font-weight': '400',
                '--inputfield-text-color': '#0E1311',
                '--inputfield-border-color': 'rgba(0,0,0,0.2)',
                '--inputfield-background-color': 'transparent',
                '--inputfield-border-width': '1px',
                '--inputfield-border-radius': '0px',

                '--common-border-color': 'rgba(0,0,0,0.15)',
                '--common-border-width': '1px',
                '--common-sidebar-width': '190px',

                '--filters-panel-bg-color': 'transparent',
                '--filters-panel-font-size': '16px',
                '--filters-panel-text-color': '#0E1311',
                '--filters-panel-horizontal-padding': '0',
                '--filters-panel-vertical-padding': '0',

                '--slider-indicator-bg-color': 'rgba(0,0,0,0.1)',
                '--slider-indicator-button-color': '#0E1311',
                '--slider-indicator-width': '190px',

                '--badge-icon-color': '#0E1311',
                '--badge-icon-font-size': 'inherit',
                '--badge-text-color': '#0E1311',
                '--badge-text-font-size': 'inherit',
                '--badge-text-letter-spacing': 'inherit',
                '--badge-text-transform': 'none',

                '--author-font-size': 'inherit',
                '--author-text-transform': 'none',

                '--avatar-thumbnail-size': '60px',
                '--avatar-thumbnail-border-radius': '100px',
                '--avatar-thumbnail-text-color': '#0E1311',
                '--avatar-thumbnail-bg-color': 'rgba(0,0,0,0.1)',

                '--photo-video-thumbnail-size': '80px',
                '--photo-video-thumbnail-border-radius': '0px',

                '--mediaslider-scroll-button-icon-color': '#0E1311',
                '--mediaslider-scroll-button-bg-color': 'rgba(255,255,255,0.85)',
                '--mediaslider-overlay-text-color': '#FFFFFF',
                '--mediaslider-overlay-bg-color': 'rgba(0,0,0,0.8)',
                '--mediaslider-item-size': '110px',

                '--pagination-tab-text-color': '#0E1311',
                '--pagination-tab-text-transform': 'none',
                '--pagination-tab-text-letter-spacing': '0',
                '--pagination-tab-text-font-size': '16px',
                '--pagination-tab-text-font-weight': '600',

                '--pagination-tab-active-text-color': '#0E1311',
                '--pagination-tab-active-text-font-weight': '600',
                '--pagination-tab-active-border-color': '#0E1311',
                '--pagination-tab-border-width': '3px',

                '--sentiment-base-font-size': '15px',
                '--sentiment-panel-bg-color': 'transparent',
                '--sentiment-panel-border-size': '1px',
                '--sentiment-panel-border-color': 'rgba(0,0,0,0.1)',
                '--sentiment-panel-border-radius': '0px',
                '--sentiment-panel-shadow-size': '0px',
                '--sentiment-panel-shadow-color': 'rgba(0,0,0,0.1)',

                '--sentiment-heading-text-color': '#0E1311',
                '--sentiment-heading-text-font-weight': '600',
                '--sentiment-heading-text-font-family': 'inherit',
                '--sentiment-heading-text-line-height': '1.4',
                '--sentiment-heading-text-letter-spacing': '0',
                '--sentiment-heading-text-transform': 'none',

                '--sentiment-body-text-color': '#0E1311',
                '--sentiment-body-text-font-weight': '400',
                '--sentiment-body-text-font-family': 'inherit',
                '--sentiment-body-text-line-height': '1.4',
                '--sentiment-body-text-letter-spacing': '0',
                '--sentiment-body-text-transform': 'none',

                '--sentiment-panel-vertical-padding': '25px',
                '--sentiment-panel-horizontal-padding': '20px',
                '--sentiment-header-text-color': 'inherit',
                '--sentiment-header-text-font-size': '12px',
                '--sentiment-header-text-font-weight': 'inherit',
                '--sentiment-header-bg-color': 'rgba(0,0,0,0.04)',
                '--sentiment-header-border-radius': '50px',
                '--sentiment-header-shadow-size': '0px',
                '--sentiment-header-shadow-color': 'rgba(0,0,0,0.1)',
                '--sentiment-header-vertical-padding': '7px',
                '--sentiment-header-horizontal-padding': '10px',

                '--sentiment-pagination-tab-text-font-size': '13px',
                '--sentiment-pagination-tab-text-font-weight': '600',
                '--sentiment-pagination-tab-text-color': '#0E1311',
                '--sentiment-pagination-tab-text-transform': 'none',
                '--sentiment-pagination-tab-text-letter-spacing': '0',
                '--sentiment-pagination-tab-active-text-color': '#0E1311',
                '--sentiment-pagination-tab-active-text-font-weight': '600',
                '--sentiment-pagination-tab-active-border-color': '#0E1311',
                '--sentiment-pagination-tab-border-width': '3px',

                '--sentiment-slider-indicator-width': '100%',
                '--sentiment-slider-indicator-height': '5px',
                '--sentiment-slider-indicator-bg-color': '#E5E5E5',
                '--sentiment-slider-indicator-border-radius': '0px',
                '--sentiment-slider-indicator-button-color': '#0E1311',
                '--sentiment-common-star-color': '#0E1311',
                '--sentiment-x-small-star-size': '16px'
              }
            }
          };

          try {
            new window.ReviewsWidget(
              `#${container.id}`,
              config
            );
          } catch (error) {
            delete container.dataset.reviewsioInitialized;
            throw error;
          }
        } catch (error) {
          delete container.dataset.reviewsioInitialized;

          console.error(
            'REVIEWS.io widget initialization failed:',
            error
          );
        }
      }
    }

    window.initReviewsIOProductWidgets = initReviewsIO;

    if (document.readyState === 'loading') {
      document.addEventListener(
        'DOMContentLoaded',
        () => initReviewsIO(),
        { once: true }
      );
    } else {
      initReviewsIO();
    }

    document.addEventListener(
      'shopify:section:load',
      (event) => initReviewsIO(event.target)
    );

    document.addEventListener(
      'shopify:section:unload',
      (event) => {
        if (
          event.target instanceof Element &&
          event.target.matches('.section-reviewsio-product')
        ) {
          event.target
            .querySelectorAll('[data-reviewsio-widget]')
            .forEach((container) => {
              delete container.dataset.reviewsioInitialized;
            });
        }
      }
    );
  })();


  } catch(e) { console.error(e); }
})();
})();
